import { InputNumber } from 'primereact/inputnumber';

const BaseInputNumber = (props)=>{
    return <InputNumber {...props}></InputNumber>
}

export default BaseInputNumber;